// global styles
import './styles/normalize.scss'
import 'lato-font'
import 'icons/styles.css'
import './styles/main.scss'
import './styles/animate.css'
import './styles/tooltip.css'
import './styles/introjs.css'
import './styles/pagination.css'
import 'vue-search-select/dist/VueSearchSelect.css'
import VTooltip from 'v-tooltip'

// shared component styles
import '@/components/shared/form/FormGroup.scss'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRx from 'vue-rx';
import IdleVue from 'idle-vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import { initAxios } from '@/services'
import * as validate from '@/validate';
import MediaQuery from 'v-media-query'
import VueGtm from 'vue-gtm'
import browserDetect from 'vue-browser-detect-plugin'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

initAxios();

Vue.use(VueRx)
Vue.use(MediaQuery)
Vue.use(browserDetect)
Vue.use(VueSidebarMenu)
Vue.use(VTooltip)
Vue.use(VueGtm, {
  id: 'GTM-5JZVM3L', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  },
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [] // If router, you can exclude some routes name (case insensitive) (optional)
})

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 12600000 // 3.5 hours
})

// shared
import Button from '@/components/shared/Button'
import Heading from '@/components/shared/Heading'
import InputGroup from '@/components/shared/form/InputGroup'
import InputGroupSimple from '@/components/shared/form/simple/InputGroup'
import InputGroupSimple2 from '@/components/shared/form/simple/InputGroup2'
import SelectGroup from '@/components/shared/form/SelectGroup'
import TextareaGroup from '@/components/shared/form/TextareaGroup'
import Paragraph from '@/components/shared/Paragraph'
import Overlay from '@/components/shared/Overlay'
import mNavigation from '@/components/sandbox/webcomponents/mNavigation'
import mDropdown from '@/components/sandbox/webcomponents/mDropdown'
import mLayout from '@/components/sandbox/webcomponents/mLayout'
import mButton from '@/components/shared/webcomponents/mButton'
import mSelect from '@/components/shared/webcomponents/mSelect'
import mInput from '@/components/shared/webcomponents/mInput'
import { MdsAlert } from '@mds/alert'

Vue.config.productionTip = false

// register vue components global
Vue.component(Button.name, Button)
Vue.component(Heading.name, Heading)
Vue.component(InputGroup.name, InputGroup)
Vue.component(Paragraph.name, Paragraph)
Vue.component(Overlay.name, Overlay)
Vue.component(InputGroupSimple.name, InputGroupSimple)
Vue.component(InputGroupSimple2.name, InputGroupSimple2)
Vue.component(SelectGroup.name, SelectGroup)
Vue.component(TextareaGroup.name, TextareaGroup)
Vue.component('mNavigation', mNavigation)
Vue.component('mDropdown', mDropdown)
Vue.component('mLayout', mLayout)
Vue.component('mButton', mButton)
Vue.component('mSelect', mSelect)
Vue.component('mInput', mInput)
Vue.component('MdsAlert', MdsAlert)

// Google recaptcha site key
Vue.prototype.$googleRecaptchaSiteKey = "6LecOWEUAAAAAL9AUSqbWz_ngQb-pBvIVWFiYQGn"


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  validate
})
